import { render, staticRenderFns } from "./remove-follower.vue?vue&type=template&id=d7071e92&"
import script from "./remove-follower.vue?vue&type=script&lang=js&"
export * from "./remove-follower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports